import React, { Fragment } from 'react';
import { ButtonGroup, Button, Input } from '@material-tailwind/react';
import TextWinds from '../common/TextWinds';
import 'react-datepicker/dist/react-datepicker.css';
import { calcDateClone, toDay } from '../../api/utils/util-func';

interface DatepickerProps {
  startDate: Date;
  endDate: Date;
  starDateHandle: (date: Date) => void;
  endDateHandle: (date: Date) => void;
}
const Datepicker = ({
  startDate,
  endDate,
  starDateHandle,
  endDateHandle,
}: DatepickerProps) => {
  const onMonthChange = (month: number) => {
    const today = toDay();
    starDateHandle(calcDateClone(today, { month: month }));
    endDateHandle(today);
  };

  const RangeButton = ({
    text,
    onClick,
  }: {
    text: string;
    onClick: () => void;
  }) => {
    return (
      <Button
        variant="text"
        className="flex-1 rounded-none px-2 py-0 hover:text-gray-700 lg:px-5"
        onClick={onClick}
      >
        <TextWinds type="button2" color="gray7">
          {text}
        </TextWinds>
      </Button>
    );
  };

  return (
    <Fragment>
      {/* 기간 선택 버튼 */}
      <ButtonGroup
        fullWidth
        variant="text"
        className="rounded border border-gray4 px-2 py-[10px]"
      >
        <RangeButton
          text="당일"
          onClick={() => {
            onMonthChange(0);
          }}
        />
        <RangeButton
          text="1개월"
          onClick={() => {
            onMonthChange(-1);
          }}
        />
        <RangeButton
          text="3개월"
          onClick={() => {
            onMonthChange(-3);
          }}
        />
        <RangeButton
          text="6개월"
          onClick={() => {
            onMonthChange(-6);
          }}
        />
      </ButtonGroup>
      {/* 날짜 선택 영역 */}
      <div className="flex flex-col items-center justify-between rounded bg-gray0 px-5 lg:flex-row lg:justify-center lg:gap-x-[60px]">
        <div className="flex flex-col gap-y-[10px] px-2 py-[10px]">
          <div className="flex gap-x-[6px]">
            <img
              src={process.env.PUBLIC_URL + '/svg/icon-calendar.svg'}
              alt="Calendar"
            />
            <TextWinds type="content_body3">조회 시작일</TextWinds>
          </div>
          <Input
            style={{ border: 'none', padding: '0', width: 'auto' }}
            labelProps={{ className: 'hidden' }}
            type="date"
            value={startDate.toISOString().split('T')[0]}
            onChange={(e) => starDateHandle(new Date(e.target.value))}
            className="bg-gray0 text-purple5"
          />
        </div>
        <div className="flex flex-col gap-y-[10px] px-2 py-[10px]">
          <div className="flex gap-x-[6px]">
            <img
              src={process.env.PUBLIC_URL + '/svg/icon-calendar.svg'}
              alt="Calendar"
            />
            <TextWinds type="content_body3">조회 종료일</TextWinds>
          </div>
          <Input
            style={{ border: 'none', padding: '0', width: 'auto' }}
            labelProps={{ className: 'hidden' }}
            type="date"
            value={endDate.toISOString().split('T')[0]}
            onChange={(e) => endDateHandle(new Date(e.target.value))}
            className="bg-gray0 text-purple5"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Datepicker;
